import { render, staticRenderFns } from "./LibraryDetailJob.vue?vue&type=template&id=5210079a&scoped=true&"
import script from "./LibraryDetailJob.vue?vue&type=script&lang=js&"
export * from "./LibraryDetailJob.vue?vue&type=script&lang=js&"
import style0 from "./LibraryDetailJob.vue?vue&type=style&index=0&id=5210079a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210079a",
  null
  
)

export default component.exports